import type { PermissionType } from '@thinkalpha/common/contracts/permissions.js';
import type {
    Group,
    GroupInvitation,
    GroupMembershipWithProfile,
    NewGroup,
    NewGroupInvitation,
    PatchGroup,
} from '@thinkalpha/ui-types/types/admin/groups';
import { createInstance, createLegacyInstance } from 'src/api';
import { appConfig } from 'src/lib/config';

const accessApi = createInstance({ baseURL: appConfig.accessApi });
const legacyAccessApi = createLegacyInstance({ baseURL: appConfig.accessApi });

export async function getFirmGroups(firmId: string) {
    const { data } = await accessApi.get<Group[]>(`/groups`, { params: { firmId } });
    return data;
}

export async function getGroup(groupId: string): Promise<Group> {
    const { data } = await accessApi.get<Group>(`/groups/${groupId}`);
    return data;
}

export async function createGroup(group: NewGroup): Promise<Group> {
    // const match = convertToValidMatch(group.name);
    const apiGroup = {
        name: group.name,
        description: group.description,
        logoUri: group.logoUri,
        firmId: group.firmId,
        roles: [],
        // match,
    };

    const { data } = await legacyAccessApi.post<Group>(`/groups`, apiGroup);
    return data;
}

export async function editGroup({ changes, groupId }: { changes: PatchGroup; groupId: string }): Promise<Group> {
    if (changes.name === '') {
        throw new Error('Group name cannot be empty.');
    }

    const { data } = await legacyAccessApi.patch<Group>(`/groups/${groupId}`, changes);
    return data;
}

export async function getGroups(): Promise<Group[]> {
    const { data } = await legacyAccessApi.get<Group[]>(`/groups`);
    return data;
}

export const getUserGroups = async (userId: string) => {
    const { data } = await legacyAccessApi.get<Group[]>(`/groups`, { params: { userId } });
    return data;
};

export async function getGroupMembers(groupId: string): Promise<GroupMembershipWithProfile[]> {
    const { data } = await legacyAccessApi.get<GroupMembershipWithProfile[]>(`/groups/${groupId}/members`);
    return data;
}

export const addGroupMember = async ({ groupId, userId }: { groupId: string; userId: string }) => {
    const { data } = await legacyAccessApi.post<GroupMembershipWithProfile[]>(`/groups/${groupId}/members/${userId}`, {
        permission: null,
    });
    return data;
};
export const deleteGroupMember = async ({ groupId, memberId }: { groupId: string; memberId: string }) => {
    const { data } = await legacyAccessApi.delete<GroupMembershipWithProfile[]>(
        `/groups/${groupId}/members/${memberId}`,
    );
    return data;
};

export const updateGroupMemberPermission = async ({
    groupId,
    memberId,
    permission,
}: {
    groupId: string;
    memberId: string;
    permission: PermissionType | null;
}) => {
    const { data } = await legacyAccessApi.patch<GroupMembershipWithProfile[]>(
        `/groups/${groupId}/members/${memberId}`,
        {
            permission,
        },
    );
    return data;
};

export const getGroupInvitees = async (groupId: string) => {
    const { data } = await legacyAccessApi.get<GroupInvitation[]>(`/groups/${groupId}/invitations`);
    return data;
};
export const inviteUserToGroup = async ({
    groupId,
    invitation,
}: {
    groupId: string;
    invitation: NewGroupInvitation;
}) => {
    const { data } = await legacyAccessApi.post(`/groups/${groupId}/invitations`, invitation);
    return data;
};
